import React from "react";
import { useUserContext } from "context/UserContext";
import InvoicesBK from "layouts/BK/invoices";
import InvoicesCM from "layouts/CM/invoices";
import { isManagementRoleLevel, normalizeRoleLevel } from "utils/roleUtils";

function Invoices() {
  const { roleLevel } = useUserContext() || {};
  const numericRoleLevel = normalizeRoleLevel(roleLevel);
  if (isManagementRoleLevel(numericRoleLevel)) {
    return <InvoicesBK />;
  }
  if (numericRoleLevel === 4) {
    return <InvoicesCM />;
  }
  return null;
}

export default Invoices;
